<template>
  <div id="disagree-button">
    <v-btn
      v-if="active=='true'"
      v-on:click="pushButton"
      class="white--text button-font"
      large
      tile
      color="#C02020"
      max-width=120
      min-width=90
    >
      <b>{{label}}</b>
    </v-btn>
    <v-btn
      v-else
      v-on:click="pushButton"
      class="button-font"
      large
      tile
      text
      elevation=1
      color="#C02020"
      outlined
      max-width=120
      min-width=90
    >
      <b>{{label}}</b>
    </v-btn>
  </div>
</template>
<script>
export default {
  props: ['label', 'active'],
  methods: {
    pushButton () {
      console.log("disagreeed")
      this.$emit("pushed")
    }
  }
}
</script>
<style>
#disagree-button .button-font {
  font-size: 16px;
}
#disagree-button .button-color {
  background-color: #4080A0
}
</style>
